export default __webpack_public_path__ + "static/media/dd.191131b1.png";